import { render } from "./BusinessPage.vue?vue&type=template&id=cff860bc"
import script from "./BusinessPage.vue?vue&type=script&lang=js"
export * from "./BusinessPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__